import React, { useEffect, useState } from "react";

import { Button } from "components";
import Modal from "components/UI/Modal/Modal";

import { TURNOS } from "../consts";
import styles from "./DetalleCeldaModal.module.scss";

// Detalle de una celda-día: horarios en solo lectura + observación editable.
// El guardado solo registra el cambio en el draft de la página (vía onGuardar);
// la persistencia real ocurre con el "Guardar cambios" general de la botonera.
export default function DetalleCeldaModal({ open, empleado, fechaLabel, celda, onGuardar, onClose }) {
    const [observacion, setObservacion] = useState("");

    useEffect(() => {
        if (open) {
            setObservacion(celda?.observacion ?? "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const turno = TURNOS.find((t) => t.codigo === (celda?.codigo ?? ""));

    return (
        <Modal open={open} title={`${empleado} — ${fechaLabel}`} onClose={onClose} narrow>
            <div className={styles.contenido}>
                <div className={styles.seccion}>
                    <span className={styles.etiqueta}>Turno del día</span>
                    {turno ? (
                        <span className={styles.turnoActual}>
                            {/* Franco y licencia no tienen horario. */}
                            <strong>{turno.codigo}</strong> — {turno.label}
                            {turno.horario ? ` (${turno.horario})` : ""}
                        </span>
                    ) : (
                        <span className={styles.sinHorarios}>Sin cargar</span>
                    )}
                </div>

                <div className={styles.seccion}>
                    <label className={styles.etiqueta} htmlFor="observacion-dia">Observación</label>
                    <textarea
                        id="observacion-dia"
                        className={styles.textarea}
                        rows={4}
                        maxLength={250}
                        placeholder="Escribí una observación para este día..."
                        value={observacion}
                        onChange={(e) => setObservacion(e.target.value)}
                    />
                </div>

                <div className={styles.botones}>
                    <Button onClick={(e) => { e.preventDefault(); onGuardar(observacion.trim()); }}>
                        <span>Guardar</span>
                    </Button>
                    <Button
                        className={styles.cancelar}
                        onClick={(e) => { e.preventDefault(); onClose(); }}
                    >
                        <span>Cancelar</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
